import Date from '../date/Date.js';

export default class DogUsabilityPass {

    constructor () {
        this.exhibitionDate = null;
        this.location = '';
        this.urls = [];
        this.levelA = false;
        this.levelB = false;
        this.levelC = false;
        this.levelD = false;
        this.levelE = false;
    }

    getLevels() {
        return [
            this.levelA ? 'A' : null,
            this.levelB ? 'B' : null,
            this.levelC ? 'C' : null,
            this.levelD ? 'D' : null,
            this.levelE ? 'E' : null
        ].filter(level => level !== null);
    }

    static fromData (data) {
        const usabilityPass = new DogUsabilityPass();
        usabilityPass.exhibitionDate = Date.fromIso8601(data.exhibitionDate);
        usabilityPass.location = data.location;
        usabilityPass.levelA = data.levels.A;
        usabilityPass.levelB = data.levels.B;
        usabilityPass.levelC = data.levels.C;
        usabilityPass.levelD = data.levels.D;
        usabilityPass.levelE = data.levels.E;
        usabilityPass.urls = {
            digitalDownload: data.urls.digitalDownload,
            digitalPreview: data.urls.digitalPreview,
            printDownload: data.urls.printDownload,
            printPreview: data.urls.printPreview,
        };

        return usabilityPass;
    }
}
